"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsWrapper";
import { VolumeType } from "@/entities/INFT";
import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
const VOLUME_TYPES = Object.values(VolumeType);
const VOLUME_TRIGGER_LABEL_CLASS = "tw-shrink-0 tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-500";
const VOLUME_TRIGGER_VALUE_CLASS = "tw-truncate tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-200 group-hover:tw-text-white";
export default function VolumeTypeDropdown(t0) {
  const $ = _c(33);
  const {
    isVolumeSort,
    selectedVolumeSort,
    setVolumeType,
    setVolumeSort
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buttonRef = useRef(null);
  let t1;
  if ($[0] !== isVolumeSort || $[1] !== setVolumeSort || $[2] !== setVolumeType) {
    t1 = volumeType => {
      setVolumeType(volumeType);
      if (!isVolumeSort) {
        setVolumeSort();
      }
      setIsOpen(false);
    };
    $[0] = isVolumeSort;
    $[1] = setVolumeSort;
    $[2] = setVolumeType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelect = t1;
  const t2 = `Volume: ${selectedVolumeSort}`;
  let t3;
  if ($[4] !== isOpen) {
    t3 = () => setIsOpen(!isOpen);
    $[4] = isOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `tw-group tw-relative tw-m-0 tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-md tw-border-0 tw-bg-transparent tw-px-0.5 tw-py-1 tw-text-left tw-no-underline tw-shadow-none tw-transition-colors tw-duration-200 after:tw-absolute after:-tw-bottom-0.5 after:tw-left-0 after:tw-h-px after:tw-w-full after:tw-origin-left after:tw-transition-transform after:tw-duration-200 after:tw-content-[''] focus:tw-outline-none focus-visible:tw-text-iron-100 focus-visible:tw-outline-none sm:tw-shrink ${isVolumeSort ? "tw-text-white after:tw-scale-x-100 after:tw-bg-primary-400" : "tw-text-iron-500 after:tw-scale-x-0 after:tw-bg-iron-700 hover:tw-text-iron-200 hover:after:tw-scale-x-100"}`;
  const t5 = isVolumeSort ? ":" : "";
  let t6;
  if ($[6] !== t5) {
    t6 = <span className={VOLUME_TRIGGER_LABEL_CLASS}>Volume{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isVolumeSort || $[9] !== selectedVolumeSort) {
    t7 = isVolumeSort && <span className={VOLUME_TRIGGER_VALUE_CLASS}>{selectedVolumeSort}</span>;
    $[8] = isVolumeSort;
    $[9] = selectedVolumeSort;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <span className="tw-flex tw-min-w-0 tw-items-center tw-gap-1.5">{t6}{t7}</span>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = `tw-h-3 tw-w-3 tw-shrink-0 tw-text-iron-500 tw-transition-transform tw-duration-200 group-hover:tw-text-iron-300 ${isOpen ? "tw-rotate-180" : ""}`;
  let t10;
  if ($[14] !== t9) {
    t10 = <FontAwesomeIcon icon={faChevronDown} className={t9} aria-hidden="true" />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== isOpen || $[17] !== t10 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t8) {
    t11 = <button ref={buttonRef} type="button" aria-haspopup="true" aria-expanded={isOpen} aria-label={t2} onClick={t3} className={t4}>{t8}{t10}</button>;
    $[16] = isOpen;
    $[17] = t10;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleSelect || $[24] !== isMobile || $[25] !== selectedVolumeSort) {
    t12 = VOLUME_TYPES.map(volumeType_0 => {
      const isActive = selectedVolumeSort === volumeType_0;
      return <li key={`volume-${volumeType_0}`} className="tw-h-full tw-min-w-0" role="none"><button type="button" data-testid="item" role="menuitem" onClick={() => handleSelect(volumeType_0)} className={`${isMobile ? "tw-px-4 tw-py-3" : "tw-px-3 tw-py-2"} tw-box-border tw-flex tw-w-full tw-max-w-full tw-items-center tw-justify-between tw-gap-x-2 tw-overflow-hidden tw-rounded-md tw-border-0 tw-bg-transparent tw-text-left tw-text-sm tw-font-medium tw-text-iron-200 tw-transition tw-duration-200 tw-ease-out hover:tw-bg-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${isActive ? "tw-bg-iron-800 tw-text-iron-100" : ""}`}><span className="tw-min-w-0 tw-flex-1 tw-truncate">{volumeType_0}</span>{isActive && <FontAwesomeIcon icon={faCheck} className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-primary-300" aria-hidden="true" />}</button></li>;
    });
    $[23] = handleSelect;
    $[24] = isMobile;
    $[25] = selectedVolumeSort;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isOpen || $[28] !== t12) {
    t13 = <CommonDropdownItemsWrapper isOpen={isOpen} filterLabel="Volume" buttonRef={buttonRef} horizontalAlign="right" portalClassName="tailwind-scope tw-z-[999]" setOpen={setIsOpen} onIsMobile={setIsMobile}>{t12}</CommonDropdownItemsWrapper>;
    $[27] = isOpen;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t11 || $[31] !== t13) {
    t14 = <div data-testid="dropdown" className="tailwind-scope tw-relative tw-inline-flex tw-shrink-0">{t11}{t13}</div>;
    $[30] = t11;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}